import { render, staticRenderFns } from "./veStuCheckStudent.vue?vue&type=template&id=7c71f5b3&scoped=true"
import script from "./veStuCheckStudent.vue?vue&type=script&lang=js"
export * from "./veStuCheckStudent.vue?vue&type=script&lang=js"
import style0 from "./veStuCheckStudent.vue?vue&type=style&index=0&id=7c71f5b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71f5b3",
  null
  
)

export default component.exports